import React from 'react';
import { Accent, ButtonType } from '../../../globals';
import Button from '../Button/Button';
import './AnnouncementHeader.scss';

interface AnnouncementHeaderProps {
    className?: string;
    children?: React.ReactNode;
}

//hardcoded it to avoid copy pasting everywhere
const AnnouncementHeader: React.FC<AnnouncementHeaderProps> = (
    props: AnnouncementHeaderProps
) => {
    return (
        <div className={props.className || 'announcement-header'}>
            <div className="announcement-header__content">
                <p>
                    📖 Check out our Introduction to Deep Learning & Neural Networks course 📖{' '}
                </p>
                <Button
                    accent={Accent.primary}
                    type={ButtonType.linkExternal}
                    onClickLink="https://www.educative.io/courses/intro-deep-learning?aff=VEe5"
                    className="announcement-header__content__button"
                >
                    Learn more
                </Button>
            </div>
        </div>
    );
};

export default AnnouncementHeader;
